import { combineReducers } from 'redux';
import { FlashMessageReducer } from './FlashMessageReducer';
import { ActivityIndicatorReducer } from './ActivityIndicatorReducer';
import { HomePageReducer } from './HomePageReducer';
import { FaultAppReducer } from './FaultAppReducer';
import { HelpboxReducer } from './HelpboxReducer';
import { ExportFaultDataReducer } from './ExportFaultDataReducer';
import { AssetAppReducer } from './AssetAppReducer';
import { NotesReducer } from './NotesReducer';
import { EnergyEfficiencyAppReducer } from './EnergyEfficiencyAppReducer';
import { EEDetailsReducer } from './EEDetailsReducer';
import { WidgetSettingReducer } from './WidgetSettingReducer';
import { MonitoringAppReducer } from './MonitoringAppReducer';
import { EEReportsReducer } from './EEReportsReducer';
import { HirarchyReducer } from './HirarchyReducer';

export default combineReducers({
  FlashMessageReducer,
  ActivityIndicatorReducer,
  HomePageReducer,
  FaultAppReducer,
  HelpboxReducer,
  ExportFaultDataReducer,
  AssetAppReducer,
  NotesReducer,
  EnergyEfficiencyAppReducer,
  EEDetailsReducer,
  WidgetSettingReducer,
  MonitoringAppReducer,
  EEReportsReducer,
  HirarchyReducer,
});
